export default "__VITE_ASSET__CjuRtZ1l__"